/**
 * OutcomesSection - What this enables for learners
 *
 * Replaces the old "How it works" section.
 * Shifts from process to outcomes - interpretive, not procedural.
 */
const OutcomesSection = () => {
    return (
        <section className="pt-10 pb-8 md:pt-12 md:pb-10 bg-background">
            <div className="container mx-auto max-w-xl px-6">
                <h2 className="text-lg md:text-xl font-semibold text-foreground text-center mb-5">
                    What this enables for learners
                </h2>

                <div className="space-y-4 text-base md:text-[17px] text-foreground/80 leading-relaxed text-center">
                    <p>
                        Students spend less time on what they already know and more time on what will actually move their score.
                    </p>
                    <p>
                        Progress becomes visible and measurable—not just a feeling, but a tracked trajectory toward readiness.
                    </p>
                    <p>
                        Every practice session is purposeful, adapting in real time as the system learns more about the student.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default OutcomesSection;
